import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';

export default class HTTPServerEndpointNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On HTTP Request';
        this.id = 'node_http_server_endpoint';
        this.linkedFeature = 'httpserver';
        this.requirements = ['network'];

        this.inputs = [];

        this.outputs = [
            {
                name: 'Requested',
                portId: 'http_requested',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'ENDPOINT',
                name: 'Endpoint',
                settingType: SettingType.OPTION,
                refId: 'http_server_endpoint',
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const endpoint = project.getFeature(this.getSettingValue('ENDPOINT'));
            let PATH = '';
            if (endpoint) {
                PATH = endpoint.getSettingValue('PATH');
                return `On HTTP Request {{$${PATH}}}`;
            }
            return this.name;
        }
        return super.getSettingValue(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### Request
HTTP ENDPOINT`;
    }
}
